import { FC, ReactNode } from "react";
import { Flex, Text } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const ContainerHeading: FC<Props> = ({ children }) => {
  return (
    <Flex
      align="center"
      bg="bg-main-accent"
      direction="column"
      h="2rem"
      justify="center"
      roundedTop="lg"
      w="full"
    >
      <Text
        as={Flex}
        color="fg-on-accent"
        fontWeight="normal"
        size="xs"
        textTransform="uppercase"
      >
        {children}
      </Text>
    </Flex>
  );
};
